/**
 * T042: useSignOut Hook
 * Mutation hook for sign-out flow with cache clearing
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { signOut } from '@/services/auth'
import { useAuthStore } from '@/stores/auth'

export function useSignOut() {
  const queryClient = useQueryClient()
  const { signOut: clearAuthStore } = useAuthStore()

  return useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      // Clear auth store
      clearAuthStore()
      // Clear all cached queries
      queryClient.clear()
      // Redirect to sign-in
      window.location.href = '/sign-in'
    },
    onError: () => {
      // Even on error, clear local state and redirect
      clearAuthStore()
      queryClient.clear()
      window.location.href = '/sign-in'
    },
  })
}
